var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import { BASE_PATH, BaseAPI } from './base';
export var AnswerBoxLength;
(function (AnswerBoxLength) {
    AnswerBoxLength["Long"] = "LONG";
    AnswerBoxLength["Short"] = "SHORT";
})(AnswerBoxLength || (AnswerBoxLength = {}));
export var AnswerStatus;
(function (AnswerStatus) {
    AnswerStatus["NotStarted"] = "NOT_STARTED";
    AnswerStatus["NotSubmitted"] = "NOT_SUBMITTED";
    AnswerStatus["Submitted"] = "SUBMITTED";
})(AnswerStatus || (AnswerStatus = {}));
export var AnswerType;
(function (AnswerType) {
    AnswerType["Stroke"] = "STROKE";
    AnswerType["Value"] = "VALUE";
})(AnswerType || (AnswerType = {}));
export var CategoryType;
(function (CategoryType) {
    CategoryType["Images"] = "HAS_IMAGES";
    CategoryType["Categories"] = "HAS_CATEGORIES";
})(CategoryType || (CategoryType = {}));
export var ConnectionStatus;
(function (ConnectionStatus) {
    ConnectionStatus["Healthy"] = "HEALTHY";
    ConnectionStatus["Unhealthy"] = "UNHEALTHY";
})(ConnectionStatus || (ConnectionStatus = {}));
export var CorrectStatus;
(function (CorrectStatus) {
    CorrectStatus["Correct"] = "CORRECT";
    CorrectStatus["PartiallyCorrect"] = "PARTIALLY_CORRECT";
    CorrectStatus["Incorrect"] = "INCORRECT";
})(CorrectStatus || (CorrectStatus = {}));
export var ExamStatus;
(function (ExamStatus) {
    ExamStatus["PreDelivery"] = "PRE_DELIVERY";
    ExamStatus["InDelivery"] = "IN_DELIVERY";
    ExamStatus["DeliveryFinished"] = "DELIVERY_FINISHED";
})(ExamStatus || (ExamStatus = {}));
export var ExamSubject;
(function (ExamSubject) {
    ExamSubject["Kokugo"] = "KOKUGO";
    ExamSubject["Sansu"] = "SANSU";
    ExamSubject["Eigo"] = "EIGO";
    ExamSubject["ChugakuKokugo"] = "CHUGAKU_KOKUGO";
    ExamSubject["ChugakuSugaku"] = "CHUGAKU_SUGAKU";
    ExamSubject["ChugakuEigo"] = "CHUGAKU_EIGO";
})(ExamSubject || (ExamSubject = {}));
export var ExamType;
(function (ExamType) {
    ExamType["UnitExamQuestion"] = "UNIT_EXAM_QUESTION";
    ExamType["EntranceExamQuestion"] = "ENTRANCE_EXAM_QUESTION";
})(ExamType || (ExamType = {}));
export var KarteSubject;
(function (KarteSubject) {
    KarteSubject["Kokugo"] = "KOKUGO";
    KarteSubject["SansuSugaku"] = "SANSU_SUGAKU";
    KarteSubject["Eigo"] = "EIGO";
    KarteSubject["Rika"] = "RIKA";
    KarteSubject["Shakai"] = "SHAKAI";
})(KarteSubject || (KarteSubject = {}));
export var KeyboardCourse;
(function (KeyboardCourse) {
    KeyboardCourse["Basic"] = "BASIC";
    KeyboardCourse["Advance"] = "ADVANCE";
})(KeyboardCourse || (KeyboardCourse = {}));
export var Order;
(function (Order) {
    Order["Asc"] = "ASC";
    Order["Desc"] = "DESC";
})(Order || (Order = {}));
export var Palette;
(function (Palette) {
    Palette["ShortAnswer"] = "SHORT_ANSWER";
    Palette["MultiChoice"] = "MULTI_CHOICE";
    Palette["Essay"] = "ESSAY";
})(Palette || (Palette = {}));
export var SortColumn;
(function (SortColumn) {
    SortColumn["Name"] = "NAME";
    SortColumn["CreatedDate"] = "CREATED_DATE";
    SortColumn["UpdatedDate"] = "UPDATED_DATE";
    SortColumn["ReturnedDate"] = "RETURNED_DATE";
    SortColumn["StartDateTime"] = "START_DATE_TIME";
})(SortColumn || (SortColumn = {}));
export var SubPartLayout;
(function (SubPartLayout) {
    SubPartLayout["SingleColumn"] = "SINGLE_COLUMN";
    SubPartLayout["SingleRow"] = "SINGLE_ROW";
    SubPartLayout["Wrap"] = "WRAP";
})(SubPartLayout || (SubPartLayout = {}));
export var TargetExam;
(function (TargetExam) {
    TargetExam["Custom"] = "CUSTOM";
    TargetExam["Preset"] = "PRESET";
})(TargetExam || (TargetExam = {}));
export const AuthHolderControllerApiAxiosParamCreator = function (configuration) {
    return {
        authHolderControllerGetUserPoolInfo: (cloudId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('authHolderControllerGetUserPoolInfo', 'cloudId', cloudId);
            const localVarPath = `/v1/auth-holder/user-pool`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (cloudId !== undefined) {
                localVarQueryParameter['cloudId'] = cloudId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const AuthHolderControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = AuthHolderControllerApiAxiosParamCreator(configuration);
    return {
        authHolderControllerGetUserPoolInfo(cloudId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authHolderControllerGetUserPoolInfo(cloudId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const AuthHolderControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AuthHolderControllerApiFp(configuration);
    return {
        authHolderControllerGetUserPoolInfo(cloudId, options) {
            return localVarFp.authHolderControllerGetUserPoolInfo(cloudId, options).then((request) => request(axios, basePath));
        },
    };
};
export class AuthHolderControllerApi extends BaseAPI {
    authHolderControllerGetUserPoolInfo(cloudId, options) {
        return AuthHolderControllerApiFp(this.configuration).authHolderControllerGetUserPoolInfo(cloudId, options).then((request) => request(this.axios, this.basePath));
    }
}
export const ExamControllerApiAxiosParamCreator = function (configuration) {
    return {
        examControllerDeleteDeliveredExam: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('examControllerDeleteDeliveredExam', 'id', id);
            const localVarPath = `/v1/exams/delivered/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerGetAnswerSheet: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('examControllerGetAnswerSheet', 'id', id);
            const localVarPath = `/v1/exams/delivered/{id}/answersheet`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerGetCustomExam: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('examControllerGetCustomExam', 'id', id);
            const localVarPath = `/v1/exams/custom/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerGetCustomExams: (order, sortColumn, limit, page, onlyMyOwn, query, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('examControllerGetCustomExams', 'order', order);
            assertParamExists('examControllerGetCustomExams', 'sortColumn', sortColumn);
            const localVarPath = `/v1/exams/custom`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (sortColumn !== undefined) {
                localVarQueryParameter['sortColumn'] = sortColumn;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (onlyMyOwn !== undefined) {
                localVarQueryParameter['onlyMyOwn'] = onlyMyOwn;
            }
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerGetDeliveredExam: (id, withFraudDetection, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('examControllerGetDeliveredExam', 'id', id);
            const localVarPath = `/v1/exams/delivered/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (withFraudDetection !== undefined) {
                localVarQueryParameter['withFraudDetection'] = withFraudDetection;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerGetDeliveredExamStatus: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('examControllerGetDeliveredExamStatus', 'id', id);
            const localVarPath = `/v1/exams/delivered/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerGetDeliveredExams: (order, sortColumn, limit, page, nextToken, query, fiscalYear, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('examControllerGetDeliveredExams', 'order', order);
            assertParamExists('examControllerGetDeliveredExams', 'sortColumn', sortColumn);
            const localVarPath = `/v1/exams/delivered`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (sortColumn !== undefined) {
                localVarQueryParameter['sortColumn'] = sortColumn;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (nextToken !== undefined) {
                localVarQueryParameter['nextToken'] = nextToken;
            }
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (fiscalYear !== undefined) {
                localVarQueryParameter['fiscalYear'] = fiscalYear;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerGetExaminationResult: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('examControllerGetExaminationResult', 'id', id);
            const localVarPath = `/v1/exams/result/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerGetExaminationResultList: (order, sortColumn, limit, page, onlyMyOwn, query, fiscalYear, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('examControllerGetExaminationResultList', 'order', order);
            assertParamExists('examControllerGetExaminationResultList', 'sortColumn', sortColumn);
            const localVarPath = `/v1/exams/result`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (sortColumn !== undefined) {
                localVarQueryParameter['sortColumn'] = sortColumn;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (onlyMyOwn !== undefined) {
                localVarQueryParameter['onlyMyOwn'] = onlyMyOwn;
            }
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (fiscalYear !== undefined) {
                localVarQueryParameter['fiscalYear'] = fiscalYear;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerGetPresetExams: (subject, examType, limit, page, query, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('examControllerGetPresetExams', 'subject', subject);
            const localVarPath = `/v1/exams/preset`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (subject !== undefined) {
                localVarQueryParameter['subject'] = subject;
            }
            if (examType !== undefined) {
                localVarQueryParameter['examType'] = examType;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerPostAdditionalTime: (id, deliveredExamAdditionalTimeDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('examControllerPostAdditionalTime', 'id', id);
            assertParamExists('examControllerPostAdditionalTime', 'deliveredExamAdditionalTimeDto', deliveredExamAdditionalTimeDto);
            const localVarPath = `/v1/exams/delivered/{id}/additional-time`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(deliveredExamAdditionalTimeDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerPostAnswerSheet: (id, answerSheetSaveDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('examControllerPostAnswerSheet', 'id', id);
            assertParamExists('examControllerPostAnswerSheet', 'answerSheetSaveDto', answerSheetSaveDto);
            const localVarPath = `/v1/exams/delivered/{id}/answersheet`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(answerSheetSaveDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerPostBeOver: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('examControllerPostBeOver', 'id', id);
            const localVarPath = `/v1/exams/delivered/{id}/over`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerPostCustomExams: (customExamSaveDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('examControllerPostCustomExams', 'customExamSaveDto', customExamSaveDto);
            const localVarPath = `/v1/exams/custom`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(customExamSaveDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerPostDeliveredExam: (deliveredExamCreateDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('examControllerPostDeliveredExam', 'deliveredExamCreateDto', deliveredExamCreateDto);
            const localVarPath = `/v1/exams/delivered`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(deliveredExamCreateDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerPostReturn: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('examControllerPostReturn', 'id', id);
            const localVarPath = `/v1/exams/result/{id}/return`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerPutBeginExam: (id, deliveredExamBeginDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('examControllerPutBeginExam', 'id', id);
            assertParamExists('examControllerPutBeginExam', 'deliveredExamBeginDto', deliveredExamBeginDto);
            const localVarPath = `/v1/exams/delivered/{id}/begin`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(deliveredExamBeginDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerPutEndExam: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('examControllerPutEndExam', 'id', id);
            const localVarPath = `/v1/exams/delivered/{id}/end`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerUpdateDeliveredExam: (id, deliveredExamUpdateDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('examControllerUpdateDeliveredExam', 'id', id);
            assertParamExists('examControllerUpdateDeliveredExam', 'deliveredExamUpdateDto', deliveredExamUpdateDto);
            const localVarPath = `/v1/exams/delivered/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(deliveredExamUpdateDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const ExamControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ExamControllerApiAxiosParamCreator(configuration);
    return {
        examControllerDeleteDeliveredExam(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerDeleteDeliveredExam(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        examControllerGetAnswerSheet(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerGetAnswerSheet(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        examControllerGetCustomExam(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerGetCustomExam(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        examControllerGetCustomExams(order, sortColumn, limit, page, onlyMyOwn, query, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerGetCustomExams(order, sortColumn, limit, page, onlyMyOwn, query, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        examControllerGetDeliveredExam(id, withFraudDetection, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerGetDeliveredExam(id, withFraudDetection, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        examControllerGetDeliveredExamStatus(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerGetDeliveredExamStatus(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        examControllerGetDeliveredExams(order, sortColumn, limit, page, nextToken, query, fiscalYear, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerGetDeliveredExams(order, sortColumn, limit, page, nextToken, query, fiscalYear, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        examControllerGetExaminationResult(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerGetExaminationResult(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        examControllerGetExaminationResultList(order, sortColumn, limit, page, onlyMyOwn, query, fiscalYear, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerGetExaminationResultList(order, sortColumn, limit, page, onlyMyOwn, query, fiscalYear, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        examControllerGetPresetExams(subject, examType, limit, page, query, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerGetPresetExams(subject, examType, limit, page, query, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        examControllerPostAdditionalTime(id, deliveredExamAdditionalTimeDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerPostAdditionalTime(id, deliveredExamAdditionalTimeDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        examControllerPostAnswerSheet(id, answerSheetSaveDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerPostAnswerSheet(id, answerSheetSaveDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        examControllerPostBeOver(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerPostBeOver(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        examControllerPostCustomExams(customExamSaveDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerPostCustomExams(customExamSaveDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        examControllerPostDeliveredExam(deliveredExamCreateDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerPostDeliveredExam(deliveredExamCreateDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        examControllerPostReturn(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerPostReturn(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        examControllerPutBeginExam(id, deliveredExamBeginDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerPutBeginExam(id, deliveredExamBeginDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        examControllerPutEndExam(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerPutEndExam(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        examControllerUpdateDeliveredExam(id, deliveredExamUpdateDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerUpdateDeliveredExam(id, deliveredExamUpdateDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const ExamControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ExamControllerApiFp(configuration);
    return {
        examControllerDeleteDeliveredExam(id, options) {
            return localVarFp.examControllerDeleteDeliveredExam(id, options).then((request) => request(axios, basePath));
        },
        examControllerGetAnswerSheet(id, options) {
            return localVarFp.examControllerGetAnswerSheet(id, options).then((request) => request(axios, basePath));
        },
        examControllerGetCustomExam(id, options) {
            return localVarFp.examControllerGetCustomExam(id, options).then((request) => request(axios, basePath));
        },
        examControllerGetCustomExams(order, sortColumn, limit, page, onlyMyOwn, query, options) {
            return localVarFp.examControllerGetCustomExams(order, sortColumn, limit, page, onlyMyOwn, query, options).then((request) => request(axios, basePath));
        },
        examControllerGetDeliveredExam(id, withFraudDetection, options) {
            return localVarFp.examControllerGetDeliveredExam(id, withFraudDetection, options).then((request) => request(axios, basePath));
        },
        examControllerGetDeliveredExamStatus(id, options) {
            return localVarFp.examControllerGetDeliveredExamStatus(id, options).then((request) => request(axios, basePath));
        },
        examControllerGetDeliveredExams(order, sortColumn, limit, page, nextToken, query, fiscalYear, options) {
            return localVarFp.examControllerGetDeliveredExams(order, sortColumn, limit, page, nextToken, query, fiscalYear, options).then((request) => request(axios, basePath));
        },
        examControllerGetExaminationResult(id, options) {
            return localVarFp.examControllerGetExaminationResult(id, options).then((request) => request(axios, basePath));
        },
        examControllerGetExaminationResultList(order, sortColumn, limit, page, onlyMyOwn, query, fiscalYear, options) {
            return localVarFp.examControllerGetExaminationResultList(order, sortColumn, limit, page, onlyMyOwn, query, fiscalYear, options).then((request) => request(axios, basePath));
        },
        examControllerGetPresetExams(subject, examType, limit, page, query, options) {
            return localVarFp.examControllerGetPresetExams(subject, examType, limit, page, query, options).then((request) => request(axios, basePath));
        },
        examControllerPostAdditionalTime(id, deliveredExamAdditionalTimeDto, options) {
            return localVarFp.examControllerPostAdditionalTime(id, deliveredExamAdditionalTimeDto, options).then((request) => request(axios, basePath));
        },
        examControllerPostAnswerSheet(id, answerSheetSaveDto, options) {
            return localVarFp.examControllerPostAnswerSheet(id, answerSheetSaveDto, options).then((request) => request(axios, basePath));
        },
        examControllerPostBeOver(id, options) {
            return localVarFp.examControllerPostBeOver(id, options).then((request) => request(axios, basePath));
        },
        examControllerPostCustomExams(customExamSaveDto, options) {
            return localVarFp.examControllerPostCustomExams(customExamSaveDto, options).then((request) => request(axios, basePath));
        },
        examControllerPostDeliveredExam(deliveredExamCreateDto, options) {
            return localVarFp.examControllerPostDeliveredExam(deliveredExamCreateDto, options).then((request) => request(axios, basePath));
        },
        examControllerPostReturn(id, options) {
            return localVarFp.examControllerPostReturn(id, options).then((request) => request(axios, basePath));
        },
        examControllerPutBeginExam(id, deliveredExamBeginDto, options) {
            return localVarFp.examControllerPutBeginExam(id, deliveredExamBeginDto, options).then((request) => request(axios, basePath));
        },
        examControllerPutEndExam(id, options) {
            return localVarFp.examControllerPutEndExam(id, options).then((request) => request(axios, basePath));
        },
        examControllerUpdateDeliveredExam(id, deliveredExamUpdateDto, options) {
            return localVarFp.examControllerUpdateDeliveredExam(id, deliveredExamUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};
export class ExamControllerApi extends BaseAPI {
    examControllerDeleteDeliveredExam(id, options) {
        return ExamControllerApiFp(this.configuration).examControllerDeleteDeliveredExam(id, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerGetAnswerSheet(id, options) {
        return ExamControllerApiFp(this.configuration).examControllerGetAnswerSheet(id, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerGetCustomExam(id, options) {
        return ExamControllerApiFp(this.configuration).examControllerGetCustomExam(id, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerGetCustomExams(order, sortColumn, limit, page, onlyMyOwn, query, options) {
        return ExamControllerApiFp(this.configuration).examControllerGetCustomExams(order, sortColumn, limit, page, onlyMyOwn, query, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerGetDeliveredExam(id, withFraudDetection, options) {
        return ExamControllerApiFp(this.configuration).examControllerGetDeliveredExam(id, withFraudDetection, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerGetDeliveredExamStatus(id, options) {
        return ExamControllerApiFp(this.configuration).examControllerGetDeliveredExamStatus(id, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerGetDeliveredExams(order, sortColumn, limit, page, nextToken, query, fiscalYear, options) {
        return ExamControllerApiFp(this.configuration).examControllerGetDeliveredExams(order, sortColumn, limit, page, nextToken, query, fiscalYear, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerGetExaminationResult(id, options) {
        return ExamControllerApiFp(this.configuration).examControllerGetExaminationResult(id, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerGetExaminationResultList(order, sortColumn, limit, page, onlyMyOwn, query, fiscalYear, options) {
        return ExamControllerApiFp(this.configuration).examControllerGetExaminationResultList(order, sortColumn, limit, page, onlyMyOwn, query, fiscalYear, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerGetPresetExams(subject, examType, limit, page, query, options) {
        return ExamControllerApiFp(this.configuration).examControllerGetPresetExams(subject, examType, limit, page, query, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerPostAdditionalTime(id, deliveredExamAdditionalTimeDto, options) {
        return ExamControllerApiFp(this.configuration).examControllerPostAdditionalTime(id, deliveredExamAdditionalTimeDto, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerPostAnswerSheet(id, answerSheetSaveDto, options) {
        return ExamControllerApiFp(this.configuration).examControllerPostAnswerSheet(id, answerSheetSaveDto, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerPostBeOver(id, options) {
        return ExamControllerApiFp(this.configuration).examControllerPostBeOver(id, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerPostCustomExams(customExamSaveDto, options) {
        return ExamControllerApiFp(this.configuration).examControllerPostCustomExams(customExamSaveDto, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerPostDeliveredExam(deliveredExamCreateDto, options) {
        return ExamControllerApiFp(this.configuration).examControllerPostDeliveredExam(deliveredExamCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerPostReturn(id, options) {
        return ExamControllerApiFp(this.configuration).examControllerPostReturn(id, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerPutBeginExam(id, deliveredExamBeginDto, options) {
        return ExamControllerApiFp(this.configuration).examControllerPutBeginExam(id, deliveredExamBeginDto, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerPutEndExam(id, options) {
        return ExamControllerApiFp(this.configuration).examControllerPutEndExam(id, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerUpdateDeliveredExam(id, deliveredExamUpdateDto, options) {
        return ExamControllerApiFp(this.configuration).examControllerUpdateDeliveredExam(id, deliveredExamUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}
export const HealthcheckControllerApiAxiosParamCreator = function (configuration) {
    return {
        healthControllerCheck: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/healthcheck`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const HealthcheckControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = HealthcheckControllerApiAxiosParamCreator(configuration);
    return {
        healthControllerCheck(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.healthControllerCheck(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const HealthcheckControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = HealthcheckControllerApiFp(configuration);
    return {
        healthControllerCheck(options) {
            return localVarFp.healthControllerCheck(options).then((request) => request(axios, basePath));
        },
    };
};
export class HealthcheckControllerApi extends BaseAPI {
    healthControllerCheck(options) {
        return HealthcheckControllerApiFp(this.configuration).healthControllerCheck(options).then((request) => request(this.axios, this.basePath));
    }
}
export const ImageControllerApiAxiosParamCreator = function (configuration) {
    return {
        imageControllerGetCategory: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('imageControllerGetCategory', 'id', id);
            const localVarPath = `/v1/images/categories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        imageControllerGetCategoryList: (categoryId, limit, offset, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('imageControllerGetCategoryList', 'categoryId', categoryId);
            const localVarPath = `/v1/images/categories`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        imageControllerGetImage: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('imageControllerGetImage', 'id', id);
            const localVarPath = `/v1/images/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        imageControllerGetImageList: (categoryId, limit, offset, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('imageControllerGetImageList', 'categoryId', categoryId);
            const localVarPath = `/v1/images`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const ImageControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ImageControllerApiAxiosParamCreator(configuration);
    return {
        imageControllerGetCategory(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.imageControllerGetCategory(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        imageControllerGetCategoryList(categoryId, limit, offset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.imageControllerGetCategoryList(categoryId, limit, offset, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        imageControllerGetImage(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.imageControllerGetImage(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        imageControllerGetImageList(categoryId, limit, offset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.imageControllerGetImageList(categoryId, limit, offset, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const ImageControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ImageControllerApiFp(configuration);
    return {
        imageControllerGetCategory(id, options) {
            return localVarFp.imageControllerGetCategory(id, options).then((request) => request(axios, basePath));
        },
        imageControllerGetCategoryList(categoryId, limit, offset, options) {
            return localVarFp.imageControllerGetCategoryList(categoryId, limit, offset, options).then((request) => request(axios, basePath));
        },
        imageControllerGetImage(id, options) {
            return localVarFp.imageControllerGetImage(id, options).then((request) => request(axios, basePath));
        },
        imageControllerGetImageList(categoryId, limit, offset, options) {
            return localVarFp.imageControllerGetImageList(categoryId, limit, offset, options).then((request) => request(axios, basePath));
        },
    };
};
export class ImageControllerApi extends BaseAPI {
    imageControllerGetCategory(id, options) {
        return ImageControllerApiFp(this.configuration).imageControllerGetCategory(id, options).then((request) => request(this.axios, this.basePath));
    }
    imageControllerGetCategoryList(categoryId, limit, offset, options) {
        return ImageControllerApiFp(this.configuration).imageControllerGetCategoryList(categoryId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }
    imageControllerGetImage(id, options) {
        return ImageControllerApiFp(this.configuration).imageControllerGetImage(id, options).then((request) => request(this.axios, this.basePath));
    }
    imageControllerGetImageList(categoryId, limit, offset, options) {
        return ImageControllerApiFp(this.configuration).imageControllerGetImageList(categoryId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }
}
export const KarteControllerApiAxiosParamCreator = function (configuration) {
    return {
        karteControllerGetExaminationResult: (id, userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('karteControllerGetExaminationResult', 'id', id);
            assertParamExists('karteControllerGetExaminationResult', 'userId', userId);
            const localVarPath = `/v1/karte/per-subject/exam-results/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        karteControllerGetKarteBySubject: (userId, subject, fiscalYear, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('karteControllerGetKarteBySubject', 'userId', userId);
            assertParamExists('karteControllerGetKarteBySubject', 'subject', subject);
            assertParamExists('karteControllerGetKarteBySubject', 'fiscalYear', fiscalYear);
            const localVarPath = `/v1/karte/per-subject`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (subject !== undefined) {
                localVarQueryParameter['subject'] = subject;
            }
            if (fiscalYear !== undefined) {
                localVarQueryParameter['fiscalYear'] = fiscalYear;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        karteControllerGetKarteSummary: (userId, fiscalYear, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('karteControllerGetKarteSummary', 'userId', userId);
            assertParamExists('karteControllerGetKarteSummary', 'fiscalYear', fiscalYear);
            const localVarPath = `/v1/karte/summary`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (fiscalYear !== undefined) {
                localVarQueryParameter['fiscalYear'] = fiscalYear;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const KarteControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = KarteControllerApiAxiosParamCreator(configuration);
    return {
        karteControllerGetExaminationResult(id, userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.karteControllerGetExaminationResult(id, userId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        karteControllerGetKarteBySubject(userId, subject, fiscalYear, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.karteControllerGetKarteBySubject(userId, subject, fiscalYear, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        karteControllerGetKarteSummary(userId, fiscalYear, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.karteControllerGetKarteSummary(userId, fiscalYear, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const KarteControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = KarteControllerApiFp(configuration);
    return {
        karteControllerGetExaminationResult(id, userId, options) {
            return localVarFp.karteControllerGetExaminationResult(id, userId, options).then((request) => request(axios, basePath));
        },
        karteControllerGetKarteBySubject(userId, subject, fiscalYear, options) {
            return localVarFp.karteControllerGetKarteBySubject(userId, subject, fiscalYear, options).then((request) => request(axios, basePath));
        },
        karteControllerGetKarteSummary(userId, fiscalYear, options) {
            return localVarFp.karteControllerGetKarteSummary(userId, fiscalYear, options).then((request) => request(axios, basePath));
        },
    };
};
export class KarteControllerApi extends BaseAPI {
    karteControllerGetExaminationResult(id, userId, options) {
        return KarteControllerApiFp(this.configuration).karteControllerGetExaminationResult(id, userId, options).then((request) => request(this.axios, this.basePath));
    }
    karteControllerGetKarteBySubject(userId, subject, fiscalYear, options) {
        return KarteControllerApiFp(this.configuration).karteControllerGetKarteBySubject(userId, subject, fiscalYear, options).then((request) => request(this.axios, this.basePath));
    }
    karteControllerGetKarteSummary(userId, fiscalYear, options) {
        return KarteControllerApiFp(this.configuration).karteControllerGetKarteSummary(userId, fiscalYear, options).then((request) => request(this.axios, this.basePath));
    }
}
export const NotificationControllerApiAxiosParamCreator = function (configuration) {
    return {
        notificationControllerGetNotification: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/notifications`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const NotificationControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = NotificationControllerApiAxiosParamCreator(configuration);
    return {
        notificationControllerGetNotification(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.notificationControllerGetNotification(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const NotificationControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = NotificationControllerApiFp(configuration);
    return {
        notificationControllerGetNotification(options) {
            return localVarFp.notificationControllerGetNotification(options).then((request) => request(axios, basePath));
        },
    };
};
export class NotificationControllerApi extends BaseAPI {
    notificationControllerGetNotification(options) {
        return NotificationControllerApiFp(this.configuration).notificationControllerGetNotification(options).then((request) => request(this.axios, this.basePath));
    }
}
export const RecognitionControllerApiAxiosParamCreator = function (configuration) {
    return {
        recognitionControllerPostOldRecognize: (recognitionRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('recognitionControllerPostOldRecognize', 'recognitionRequestDto', recognitionRequestDto);
            const localVarPath = `/v1/recognitions/rest/handwriting/recognize`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(recognitionRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        recognitionControllerPostRecognize: (recognitionRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('recognitionControllerPostRecognize', 'recognitionRequestDto', recognitionRequestDto);
            const localVarPath = `/v1/recognitions/recognize`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(recognitionRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const RecognitionControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = RecognitionControllerApiAxiosParamCreator(configuration);
    return {
        recognitionControllerPostOldRecognize(recognitionRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.recognitionControllerPostOldRecognize(recognitionRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        recognitionControllerPostRecognize(recognitionRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.recognitionControllerPostRecognize(recognitionRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const RecognitionControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RecognitionControllerApiFp(configuration);
    return {
        recognitionControllerPostOldRecognize(recognitionRequestDto, options) {
            return localVarFp.recognitionControllerPostOldRecognize(recognitionRequestDto, options).then((request) => request(axios, basePath));
        },
        recognitionControllerPostRecognize(recognitionRequestDto, options) {
            return localVarFp.recognitionControllerPostRecognize(recognitionRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};
export class RecognitionControllerApi extends BaseAPI {
    recognitionControllerPostOldRecognize(recognitionRequestDto, options) {
        return RecognitionControllerApiFp(this.configuration).recognitionControllerPostOldRecognize(recognitionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    recognitionControllerPostRecognize(recognitionRequestDto, options) {
        return RecognitionControllerApiFp(this.configuration).recognitionControllerPostRecognize(recognitionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}
export const SchoolControllerApiAxiosParamCreator = function (configuration) {
    return {
        schoolControllerGetSchoolOption: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/schools/option`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        schoolControllerPutSchoolOption: (updateSchoolOptionDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('schoolControllerPutSchoolOption', 'updateSchoolOptionDto', updateSchoolOptionDto);
            const localVarPath = `/v1/schools/option`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateSchoolOptionDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const SchoolControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = SchoolControllerApiAxiosParamCreator(configuration);
    return {
        schoolControllerGetSchoolOption(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.schoolControllerGetSchoolOption(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        schoolControllerPutSchoolOption(updateSchoolOptionDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.schoolControllerPutSchoolOption(updateSchoolOptionDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const SchoolControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SchoolControllerApiFp(configuration);
    return {
        schoolControllerGetSchoolOption(options) {
            return localVarFp.schoolControllerGetSchoolOption(options).then((request) => request(axios, basePath));
        },
        schoolControllerPutSchoolOption(updateSchoolOptionDto, options) {
            return localVarFp.schoolControllerPutSchoolOption(updateSchoolOptionDto, options).then((request) => request(axios, basePath));
        },
    };
};
export class SchoolControllerApi extends BaseAPI {
    schoolControllerGetSchoolOption(options) {
        return SchoolControllerApiFp(this.configuration).schoolControllerGetSchoolOption(options).then((request) => request(this.axios, this.basePath));
    }
    schoolControllerPutSchoolOption(updateSchoolOptionDto, options) {
        return SchoolControllerApiFp(this.configuration).schoolControllerPutSchoolOption(updateSchoolOptionDto, options).then((request) => request(this.axios, this.basePath));
    }
}
export const StorageControllerApiAxiosParamCreator = function (configuration) {
    return {
        storageControllerUpload: (file, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/storages/files/upload`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const StorageControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = StorageControllerApiAxiosParamCreator(configuration);
    return {
        storageControllerUpload(file, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.storageControllerUpload(file, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const StorageControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = StorageControllerApiFp(configuration);
    return {
        storageControllerUpload(file, options) {
            return localVarFp.storageControllerUpload(file, options).then((request) => request(axios, basePath));
        },
    };
};
export class StorageControllerApi extends BaseAPI {
    storageControllerUpload(file, options) {
        return StorageControllerApiFp(this.configuration).storageControllerUpload(file, options).then((request) => request(this.axios, this.basePath));
    }
}
//# sourceMappingURL=api.js.map